import {
  AISMLLMAPI,
  BPIAM_API,
  KNOWLEDGE,
  KNOWLEDGE_API,
  MARKETING_API,
  OSS_API,
} from '@/constants/API';
import { request } from '@umijs/max';


// 生成方案 热点
export async function hotserBuildAScenario(params: any, signal: any) {
  return request(`${MARKETING_API}/scheme/parameter/hotspotBuildAScenario`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
    signal
  });
}

// 生成方案 日历
export async function dataBuildAScenario(params: any, signal: any) {
  if(!params.dataId) {
    delete params.dataId
  }
  return request(`${MARKETING_API}/scheme/parameter/dataBuildAScenario`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
    signal
  });
}

// 继续生成
export async function schemeContinueImage(params: any) {
  return request(`${MARKETING_API}/scheme/image/continueImage`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}


// 请求图片 渠道id
export async function getHotspotSchemeImage({
  channelId,
}: {
  channelId: string | undefined;
}, signal: any) {
  return request(`${MARKETING_API}/hotspot/scheme/image/getImages/${channelId}`, {
    method: 'get',
    signal
  });
}

// 扩写
export async function http_essayExpand(params: any) {
  return request(`${MARKETING_API}/scheme/optimize/essayExpand`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}
// 润色
export async function http_essayPolish(params: any) {
  return request(`${MARKETING_API}/scheme/optimize/essayPolish`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}

// 修改保存历史记录
export async function http_updateScheme(params: any) {
  return request(`${MARKETING_API}/hotspot/scheme/details/operate/updateScheme`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

export async function taskIdDesign(taskId: any) {
  return request(`${MARKETING_API}/adhesive/bandage/image/taskIdDesign/${taskId}`)
}

// 一键SEO优化
export async function http_SEOOptimization(params: any) {
  return request(`${MARKETING_API}/scheme/optimize/SEOOptimization`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  })
};


// 加入方案
export async function http_add_scheme_to_user(params: any) {
  return request(`${MARKETING_API}/scheme/parameter/add_scheme_to_user`, {
    method: 'PUT',
    data: params,
  })
};



// 历史记录
export async function http_updateRecordList({
  socialmedia,
  id
}: any) {
  return request(`${MARKETING_API}/hotspot/scheme/details/operate/updateRecordList/${id}/${socialmedia}`, {
    method: 'GET',
   
  })
};


// 日历分析结果
export async function http_dataGenerateAnalysisResults(params: any, signal: any) {
  return request(`${MARKETING_API}/scheme/analysis/dataGenerateAnalysisResults`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
    signal
  })
};

// 热点分析结果
export async function http_hotspotGenerateAnalysisResults(params: any, signal: any) {
  return request(`${MARKETING_API}/scheme/analysis/hotspotGenerateAnalysisResults`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
    signal
  })
};

// 还原历史记录
export async function http_operateRestores({
  detailsId,recordId
}:any) {
  return request(`${MARKETING_API}/hotspot/scheme/details/operate/restores/${detailsId}/${recordId}`, {
    method: 'GET',
   
  })
};